import {AuthContext} from 'packages/context/AuthContext';
import {useContext} from 'react';
import {Redirect, Route, RouteProps} from 'react-router-dom';

type AuthContextType = {
  /** Indicar si el usuario esta autenticado o no */
  authenticated: boolean;
  /** Objeto user que vuelve de firebase */
  user: firebase.default.User | null;
  /** Estado de cargando de la petición */
  loading: boolean;
  /** Token de autenticación */
  idToken: string | null;
  /** Verify if claims admin */
  isAdmin: boolean;
};

function PrivateRoute({component: Component, ...rest}: RouteProps) {
  const auth = useContext<AuthContextType | null>(AuthContext);
  if (!Component) return null;

  return (
    <Route
      {...rest}
      render={(props) =>
        auth?.authenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}

export default PrivateRoute;
